/**
 * Maps raw WS frame status strings to the four internal canonical values:
 *   ALL_COMPLETED | ALL_FAILED | PARTIAL_COMPLETED | (pass-through for intermediate statuses)
 *
 * Backend aliases (DONE, SUCCESS, PARTIAL, ERROR…) are normalised here so
 * every *WebSocketService can switch on a stable set of values without
 * forward-compat fragility.
 */
export function normalizeWsStatus(rawStatus) {
  if (rawStatus == null) return rawStatus;
  const status = String(rawStatus).trim().toUpperCase();

  switch (status) {
    case "ALL_COMPLETED":
    case "DONE":
    case "SUCCESS":
    case "SUCCEEDED":
    case "COMPLETED_ALL":
    case "FINISHED":
      return "ALL_COMPLETED";

    case "ALL_FAILED":
    case "ERROR":
    case "FAILED_ALL":
    case "FAILURE":
    // Terminal — the job's owning backend instance died mid-run (restart /
    // redeploy / crash) and can never emit its own terminal frame. Resolved
    // server-side to INTERRUPTED so the card stops spinning; surfaced as a
    // failure the user can retry.
    case "INTERRUPTED":
      return "ALL_FAILED";

    case "PARTIAL":
    case "PARTIALLY_COMPLETED":
    case "ALL_COMPLETED_WITH_ERRORS":
      // Terminal — the job committed its successful items (capacity reset
      // swaps the succeeded resources; failed ones keep their old rows).
      // failedCount > 0 derives the "error" card state in the selector
      // without needing a separate Redux action type.
      return "ALL_COMPLETED";

    default:
      // Intermediate: STARTED, QUEUED, PROJECT_STARTED, COMPLETED, FAILED
      return status;
  }
}
